<!--
 * @Descripttion:
 * @Author: zenghua.wang
 * @Date: 2021-10-21 14:26:46
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-11-26 09:28:36
-->
<template>
  <div
    v-show="visible"
    :class="setClass('mask')"
    :style="styleSize"
  >
    <div :class="setClass('spinner')">
      <svg
        viewBox="25 25 50 50"
        class="circular"
        v-if="spinner"
      >
        <circle
          cx="50"
          cy="50"
          r="20"
          fill="none"
          class="path"
        ></circle>
      </svg>
      <p :class="setClass('text')">{{text}}</p>
    </div>
  </div>
</template>

<script>
import bem from '@/dragComponents/mixins/bem'

export default {
  name: 'customg-loading',
  mixins: [bem],
  data() {
    return {
      text: null,
      spinner: null,
      background: null,
      fullscreen: true,
      visible: false,
      lock: false,
      customClass: '',
    }
  },
  computed: {
    styleSize() {
      return {
        position: this.lock ? 'fixed' : 'absolute',
        backgroundColor: this.background,
      }
    },
  },
  methods: {
    setText(text) {
      this.text = text
    },
  },
}
</script>
<style lang="scss" scoped>
.customg-loading {
  &-mask {
    position: absolute;
    z-index: 2000;
    margin: 0;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition: opacity 0.3s;
  }

  &-spinner {
    top: 50%;
    margin-top: -30px;
    width: 100%;
    text-align: center;
    position: absolute;

    .circular {
      height: 30px;
      width: 30px;
      animation: loading-rotate 2s linear infinite;
    }

    .path {
      animation: loading-dash 1.5s ease-in-out infinite;
      stroke-dasharray: 90, 150;
      stroke-dashoffset: 0;
      stroke-width: 2;
      stroke: #409eff;
      stroke-linecap: round;
    }
  }

  &-text {
    font-size: 12px;
    color: #409eff;
  }
}

@keyframes loading-rotate {
  to {
    transform: rotate(1turn);
  }
}
@keyframes loading-dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -40px;
  }
  to {
    stroke-dasharray: 90, 150;
    stroke-dashoffset: -120px;
  }
}
</style>
